import script from "./LitmusTestPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LitmusTestPage.vue?vue&type=script&setup=true&lang=ts"

import "./LitmusTestPage.vue?vue&type=style&index=0&id=4f28a056&scoped=true&lang=css"
import "./LitmusTestPage.vue?vue&type=style&index=1&id=4f28a056&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f28a056"]])

export default __exports__